import {
  Blank,
  Bold,
  CodeInline,
  Color,
  ColorHighlighter,
  Emoji,
  Italic,
  Link,
  Mention,
  SelectionToolbar,
  Strikethrough,
  TypographyInputRules,
  Underline,
} from '@lyearn/lygo-blocks';

export const fillInTheBlanksExtensions = [
  CodeInline,
  Emoji,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  SelectionToolbar,
  Color,
  Mention,
  TypographyInputRules,
  ColorHighlighter,
  Blank,
];
